import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f7290d5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fixation" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "active-ps" }
const _hoisted_4 = { class: "page-index" }
const _hoisted_5 = { class: "timer-support" }
const _hoisted_6 = { class: "product-list" }
const _hoisted_7 = { class: "product" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_Header = _resolveComponent("Header")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_count_down = _resolveComponent("count-down")!
  const _component_FlashGoodBox = _resolveComponent("FlashGoodBox")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_Scrolltop = _resolveComponent("Scrolltop")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header, {
      backgroundColor: "linear-gradient(to right,#ff582a, #ff2542)",
      title: "Flash Sale",
      fontColor: "#fff",
      skipPath: "/home"
    }, {
      right: _withCtx(() => [
        _createVNode(_component_van_icon, {
          name: "shopping-cart-o",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.router.push("/cart"))),
          size: "24"
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_tabs, {
        active: $setup.active,
        "onUpdate:active": _cache[1] || (_cache[1] = ($event: any) => (($setup.active) = $event))
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.seckillList.timeList, (item, index) => {
            return (_openBlock(), _createBlock(_component_van_tab, {
              key: item.start_timestamp
            }, {
              title: _withCtx(() => [
                _createElementVNode("div", {
                  class: "inside-groove",
                  onClick: ($event: any) => ($setup.timingClick(item.hour, index))
                }, [
                  _createElementVNode("p", _hoisted_3, _toDisplayString(item.hour), 1),
                  _createElementVNode("span", null, _toDisplayString(item.text), 1)
                ], 8, _hoisted_2)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["active"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _withDirectives(_createElementVNode("div", _hoisted_5, [
        _createVNode(_component_count_down, {
          timestamp: $setup.flash_sale_times_arr,
          havebegun: $setup.havebegun,
          openDown: true
        }, null, 8, ["timestamp", "havebegun"])
      ], 512), [
        [_vShow, $setup.active == 0 && $setup.havebegun]
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_van_list, {
          loading: $setup.loading,
          "onUpdate:loading": _cache[2] || (_cache[2] = ($event: any) => (($setup.loading) = $event)),
          finished: $setup.finished,
          "finished-text": "No more",
          onLoad: $setup.onLoad,
          "loading-text": "loading"
        }, {
          default: _withCtx(() => [
            _createElementVNode("ul", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.seckillList.dataList, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.goods_id
                }, [
                  _createVNode(_component_FlashGoodBox, {
                    item: item,
                    random: parseInt(Math.floor(Math.random() * (80 - 20) + 20)),
                    status_name: $setup.status_name
                  }, null, 8, ["item", "random", "status_name"])
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["loading", "finished", "onLoad"])
      ]),
      _createVNode(_component_Scrolltop)
    ])
  ], 64))
}